import api from '../api'

import {
    fetchFindDataByReStart,
    fetchFindDataByReSuccess,
    fetchFindDataByReFail,
} from '../reducers/endpoints/findDataByRE'
import {take, put, call} from 'redux-saga/effects'

export function* fetchFindDataByRe(mss) {
  console.log(mss)
  const url = `/usuario/getporre/${mss.mss.re}/${mss.mss.company}`

  console.log('URL:::', url)
  //const userToken = localStorage.getItem('token')

  const headerParams = {
    headers: {
  //    Authorization: `Bearer ${ userToken }`
    }
  }

  try {
      console.log('***********-*-*-*-*-*-*')
    const {data: findDataByRE} = yield call([api, 'get'], url, headerParams)
    console.log('fetchFindDataByReSuccess',findDataByRE)
    yield put(fetchFindDataByReSuccess(findDataByRE))
  } catch (error) {
    console.log('42 error fetchFindDataByReSuccess', error)
    yield put(fetchFindDataByReFail(error))
  }
}

export function* watchFetchFindDataByRe() {
  while (true) {
    const {
      payload: mss
    } = yield take(fetchFindDataByReStart)
    yield call(fetchFindDataByRe, mss)
  }
}